import React from 'react';
import { CheckIcon, SparklesIcon } from 'lucide-react';
const PricingSection = () => {
  return <section id="pricing" className="py-4 opacity-5 pointer-events-none h-16 overflow-hidden" aria-hidden="true" data-id="element-345">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-346">
        <div className="text-center" data-id="element-347">
          <h2 className="text-sm font-bold text-[#E87B5C]" data-id="element-348">
            Premium features coming soon
          </h2>
        </div>
        {/* Hidden pricing content preserved for future use */}
        <div className="hidden" data-id="element-349">
          {/* Two-column pricing cards */}
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-350">
            {/* Free Plan */}
            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-gray-200" data-id="element-351">
              <div className="p-8 md:p-10" data-id="element-352">
                {/* Header with price */}
                <div className="text-center mb-8" data-id="element-353">
                  <div className="inline-flex items-center justify-center mb-3" data-id="element-354">
                    <h3 className="text-2xl font-bold text-gray-800" data-id="element-355">
                      Free Plan
                    </h3>
                  </div>
                  <p className="text-4xl font-bold text-gray-900" data-id="element-356">
                    $0{' '}
                    <span className="text-base font-normal text-gray-500" data-id="element-357">
                      forever
                    </span>
                  </p>
                </div>
                {/* CTA Button */}
                <div className="mb-10" data-id="element-358">
                  <a href="#" className="block w-full py-4 px-6 bg-gray-100 text-gray-800 text-center text-lg font-medium rounded-full hover:bg-gray-200 transition-all" data-id="element-359">
                    Get Started
                  </a>
                </div>
                {/* Divider */}
                <div className="relative my-8" data-id="element-360">
                  <div className="absolute inset-0 flex items-center" data-id="element-361">
                    <div className="w-full border-t border-gray-200" data-id="element-362"></div>
                  </div>
                  <div className="relative flex justify-center" data-id="element-363">
                    <span className="bg-white px-4 text-sm text-gray-500" data-id="element-364">
                      Free Features
                    </span>
                  </div>
                </div>
                {/* Features List */}
                <div className="space-y-4" data-id="element-365">
                  <div className="flex items-start" data-id="element-366">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-367">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-368" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-369">
                      Basic reframing suggestions
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-370">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-371">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-372" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-373">
                      Simple tone detection
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-374">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-375">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-376" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-377">
                      5 reframes per day
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-378">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-379">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-380" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-381">
                      Community support
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* Premium Plan */}
            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-[#E87B5C]/20 relative" data-id="element-382">
              {/* Popular badge */}
              <div className="absolute top-0 right-0 bg-gradient-to-r from-[#E87B5C] to-[#FFD700] text-white text-xs font-bold px-4 py-1 rounded-bl-lg" data-id="element-383">
                MOST POPULAR
              </div>
              <div className="p-8 md:p-10" data-id="element-384">
                {/* Header with price */}
                <div className="text-center mb-8" data-id="element-385">
                  <div className="inline-flex items-center justify-center mb-3" data-id="element-386">
                    <SparklesIcon className="h-6 w-6 text-[#FFD700] mr-2" data-id="element-387" />
                    <h3 className="text-2xl font-bold text-[#E87B5C]" data-id="element-388">
                      Premium Plan
                    </h3>
                  </div>
                  <p className="text-4xl font-bold text-gray-900" data-id="element-389">
                    $9.99{' '}
                    <span className="text-base font-normal text-gray-500" data-id="element-390">
                      per month
                    </span>
                  </p>
                </div>
                {/* CTA Button */}
                <div className="mb-10" data-id="element-391">
                  <a href="#" className="block w-full py-4 px-6 bg-gradient-to-r from-[#E87B5C] to-[#E87B5C]/90 text-white text-center text-lg font-medium rounded-full hover:shadow-md transition-all transform hover:-translate-y-0.5" data-id="element-392">
                    Upgrade Now
                  </a>
                </div>
                {/* Divider */}
                <div className="relative my-8" data-id="element-393">
                  <div className="absolute inset-0 flex items-center" data-id="element-394">
                    <div className="w-full border-t border-gray-200" data-id="element-395"></div>
                  </div>
                  <div className="relative flex justify-center" data-id="element-396">
                    <span className="bg-white px-4 text-sm text-gray-500" data-id="element-397">
                      Premium Features
                    </span>
                  </div>
                </div>
                {/* Features List */}
                <div className="space-y-4" data-id="element-398">
                  <div className="flex items-start" data-id="element-399">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-400">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-401" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-402">
                      Everything in Free
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-403">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-404">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-405" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-406">
                      Unlimited reframes
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-407">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-408">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-409" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-410">
                      Advanced analytics
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-411">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-412">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-413" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-414">
                      Personalized insights
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-415">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-416">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-417" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-418">
                      Emotional tracking
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-419">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-420">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-421" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-422">
                      Priority support
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-423">
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-424">
              All premium features are designed to help you manage emotions and
              communicate more effectively. Start with a 7-day free trial, no
              credit card required.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default PricingSection;